"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountdownText = CountdownText;
var jsx_runtime_1 = require("react/jsx-runtime");
// ================================================================
// v2/components/CountdownText/index.tsx
// 締切カウントダウン文字列。NotificationItem / カード類で締切までの
// 残り時間を強調表示するための単一 Typography 部品。
//
// - textStyles.countdown (14px / W600 / letterSpacing -0.05)
// - 色は variant で切替: primary→info, warning→warning
//   いずれも theme.palette.v2 (useV2Palette) から取得。
// ================================================================
var material_1 = require("@mui/material");
var theme_1 = require("../../theme");
var tokens_1 = require("../../tokens");
function CountdownText(_a) {
    var value = _a.value, _b = _a.variant, variant = _b === void 0 ? 'primary' : _b;
    var p = (0, theme_1.useV2Palette)();
    var color = variant === 'warning'
        ? p.foreground.semantic.warning
        : p.foreground.semantic.info;
    return ((0, jsx_runtime_1.jsx)(material_1.Typography, { sx: __assign(__assign({}, tokens_1.textStyles.countdown), { color: color, whiteSpace: 'nowrap' }), children: value }));
}
